import * as React from 'react'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import { CheckIcon, MinusIcon } from 'lucide-react'

import { LoadingSpinner } from '@/components/LoadingSpinner'
import { cn } from '@/lib/utils'

export type Props = React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  isLoading?: boolean
}

export function Checkbox({
  className,
  isLoading = false,
  checked,
  ...props
}: Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      checked={checked}
      className={cn(
        'size-4',
        !isLoading &&
          'peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          data-testid="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none"
        >
          {checked === 'indeterminate' ? (
            <MinusIcon data-testid="minus-icon" className="size-3.5" />
          ) : (
            <CheckIcon data-testid="check-icon" className="size-3.5" />
          )}
        </CheckboxPrimitive.Indicator>
      )}
    </CheckboxPrimitive.Root>
  )
}
